import React, { FC, ReactNode } from 'react';
import { useSettings } from '@wix/yoshi-flow-editor/build/cjs/tpa-settings/react';
import { useInvertInfoPosition } from '../../../hooks/useInvertInfoPosition';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { Card as CardComponent } from 'wix-ui-tpa';
import { ServiceLayoutProps } from '../ServiceCard';
import {
  ImageShapeOptions,
  ServiceListLayoutOptions,
} from '../../../../../../types/types';
import { classes, st } from './Card.st.css';
import { DataHooks as CardDataHooks } from './consts';
import { DataHooks } from '../consts';
import settingsParams from '../../../../settingsParams';
import { useWidgetViewModel } from '../../../hooks/useWidgetViewModel';

export const Card: FC<ServiceLayoutProps> = (props) => {
  const { image, info } = props;
  const { isMobile } = useEnvironment();
  const settings = useSettings();
  const { serviceListLayout } = useWidgetViewModel();

  const isGrid = serviceListLayout === ServiceListLayoutOptions.GRID;
  const invertInfoPosition = useInvertInfoPosition() && !isGrid;

  const getCardContent = () => {
    return invertInfoPosition ? (
      <>
        <Info info={info} />
        <Image image={image} />
      </>
    ) : (
      <>
        <Image image={image} />
        <Info info={info} />
      </>
    );
  };

  return (
    <CardComponent
      className={st(classes.root, {
        isMobile,
        isGrid,
        invertInfoPosition,
        applyRatio: !isGrid,
        flipRatio: settings.get(settingsParams.flipImageAndTextRatio),
        isRoundImage:
          settings.get(settingsParams.serviceImageShape) ===
          ImageShapeOptions.ROUND,
      })}
      stacked={isGrid}
      data-hook={DataHooks.CARD}
    >
      {getCardContent()}
    </CardComponent>
  );
};

const Image: FC<{ image: ReactNode }> = ({ image }) => {
  return image ? (
    <CardComponent.Container
      data-hook={CardDataHooks.IMAGE}
      className={classes.media}
    >
      {image}
    </CardComponent.Container>
  ) : null;
};

const Info: FC<{ info: ReactNode }> = ({ info }) => {
  return (
    <CardComponent.Container
      data-hook={CardDataHooks.INFO}
      className={classes.info}
    >
      {info}
    </CardComponent.Container>
  );
};
